/** POST PDF bytes to server cache (admin API — supports large files). */
export async function uploadMagazineToCache(
  storageKey: string,
  file: File | Blob,
): Promise<void> {
  const res = await fetch(
    `/api/admin/magazine-cache?storageKey=${encodeURIComponent(storageKey)}`,
    {
      method: "POST",
      body: file,
      headers: {
        "Content-Type":
          file instanceof File && file.type ? file.type : "application/pdf",
      },
    },
  );
  const data = (await res.json()) as { error?: string };
  if (!res.ok) {
    throw new Error(data.error ?? "Could not cache PDF on server");
  }
}
